import React from 'react'
import { TabbedForm, EditProps, Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import LocationFormTab from './eventsFormTabs/LocationTab/LocationFormTab'
import VirtualFormTab from './eventsFormTabs/ExperienceTab/VirtualFormTab'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import BaseProductTab from './eventsFormTabs/BaseProductTab/BaseProductTab'
import BriefRecapTab from './eventsFormTabs/BriefRecapTab'
import DrinksFormTab from './eventsFormTabs/DrinkTab/DrinksFormTab'
import PhysicalFormTab from './eventsFormTabs/ExperienceTab/PhysicalFormTab'
import FoodFormTab from './eventsFormTabs/FoodTab/FoodFormTab'
import GeneralTab from './eventsFormTabs/GeneralTab'
import ProfessionalsTab from './eventsFormTabs/ProfessionaTab/ProfessionalsTab'
import LabeledTextField from 'ui-shared/LabeledFields/LabeledTextField'
import LabeledNumberField from 'ui-shared/LabeledFields/LabeledNumberField'
import { yupResolver } from '@hookform/resolvers/yup'
import { eventVS } from 'services/validations/operations/events'
import EventEditReadonlyFields from './EventEditReadOnlyFields'

const EventEdit: React.FC<EditProps> = () => {
  return (
    <SectionWrapper>
      <Edit>
        <>
          <EventEditReadonlyFields />

          <TabbedForm
            toolbar={<WithDeleteModalToolbar />}
            resolver={yupResolver(eventVS)}
          >
            <GeneralTab>
              <LabeledNumberField source="id" label="form.fields.eventId" />
              <LabeledTextField source="name" label="form.fields.name" />
            </GeneralTab>

            <ProfessionalsTab />

            <DrinksFormTab />

            <FoodFormTab />

            <VirtualFormTab />

            <PhysicalFormTab />

            <LocationFormTab />

            <BaseProductTab product="music" />

            <BaseProductTab product="rent" />

            <BriefRecapTab />
          </TabbedForm>
        </>
      </Edit>
    </SectionWrapper>
  )
}

export default EventEdit
